export interface ReturnFormatArray<OKType, ErrorType> extends Array<OKType | ErrorType> {
  [0]: OKType;
  [1]: ErrorType;
}

export const isReturnFormatArray = (arr: unknown): arr is ReturnFormatArray<unknown, unknown> => {
  if (
    Array.isArray(arr) &&
    arr.length === 2 &&
    !(arr[0] instanceof Error) &&
    (arr[1] instanceof Error || arr[1] === null)
  )
    return true;

  return false;
};

export const createReturnFormatArray = <OKType, ErrorType>(
  okData: OKType,
  errorData: ErrorType
): ReturnFormatArray<OKType, ErrorType> => {
  const returned: ReturnFormatArray<OKType, ErrorType> = [okData, errorData];
  return returned as ReturnFormatArray<OKType, ErrorType>;
};

/**
 * Like `setInterval` only the result of `cb` is
 * awaited before starting the next timer.
 * @param cb A callback which returns a promise
 * @param ms The number of milliseconds betwee intervals
 * @returns A function which stops the interval
 */
export const awaitInterval = (cb: () => Promise<unknown>, ms: number): (() => void) => {
  let timer: ReturnType<typeof setTimeout>;
  const stop = () => clearTimeout(timer);
  const run = () => {
    timer = setTimeout(async () => {
      await cb();
      run();
    }, ms);
  };

  run();

  return stop;
};
